export default {
  BACKSPACE: 8,
  DELETE: 46,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFTARROW: 37,
  UPARROW: 38,
  RIGHTARROW: 39,
  DOWNARROW: 40,

  NUMBER0: 48,
  NUMBER9: 57,
  NUMBERPAD0: 96,
  NUMBERPAD9: 105,

  DASH: 189,
  PERIOD: 190,

  SUBTRACT: 109,
  DECIMAL_POINT: 110,
}
